import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import YearEndingFoodCategory from '../YearEndingFoodCategory';
import BuffetDinner from '../BuffetDinner';


const HappyEnding = () => {
  return (
    <section className="sp-cnt-blk">
      <Container>
        <YearEndingFoodCategory />
        <BuffetDinner />
      </Container>
    </section>      
  )
}

export default HappyEnding